import { consoleSandbox } from '@sentry/core';
import { FAKE_FUNCTION } from './common.js';

const FEEDBACK_INTEGRATION_METHODS = ["attachTo", "createForm", "createWidget", "remove"];
const feedbackIntegrationShim = Object.assign(
  (_options) => {
    consoleSandbox(() => {
      console.warn("You are using feedbackIntegration() even though this bundle does not include feedback.");
    });
    return {
      name: "Feedback",
      ...FEEDBACK_INTEGRATION_METHODS.reduce((acc, method) => {
        acc[method] = FAKE_FUNCTION;
        return acc;
      }, {})
    };
  },
  {
    _isShim: true
  }
);

export { feedbackIntegrationShim };
//# sourceMappingURL=Feedback.js.map
